import { Injectable } from '@angular/core';
import { interval, Subject, Subscription } from 'rxjs';
import { take, timeout } from 'rxjs/operators';
import { HttpService } from './http.service';

@Injectable({
  providedIn: 'root'
})
export class PagseguroService {

  submitingCardBrand: boolean = false;
  private PagSeguroDirectPayment: any;
  private hasPagseguroSession: boolean = false;
  private pagseguroSessionSubscription: Subscription;
  private submitCartSubscription: Subscription;

  
  public get HasPagseguroSession() : boolean {
    return this.hasPagseguroSession;
  }
  

  constructor(
    private http: HttpService
  ) {
    this.PagSeguroDirectPayment = (window as any).PagSeguroDirectPayment;
  }

  hasCardCache() {
    return localStorage.getItem('cardCache') ? JSON.parse(localStorage.getItem('cardCache')) : null;
  }

  getCardBrand(cardNumber: string, subject: Subject<any>) {

    this.submitingCardBrand = true;
    
    this.PagSeguroDirectPayment.getBrand({              
      cardBin: cardNumber.substr(0, 6),
      success: (response) => {
        const { 
          brand: { name }
        } = response;
        subject.next(name);
      },
      error: () => {        
        subject.next(false);
      },
      complete: () => {
        this.submitingCardBrand = false;
      }
    })
  }

  getPagseguroSession() {

    this.http.get('pagseguro:session')
      .pipe(timeout(3000))
      .subscribe(
        (result: any) => {
          this.PagSeguroDirectPayment.setSessionId(result.data);
          this.hasPagseguroSession = true;
          if(this.pagseguroSessionSubscription)
            this.pagseguroSessionSubscription.unsubscribe();
        },
        err => {
          
          if(!this.pagseguroSessionSubscription)
            this.pagseguroSessionSubscription = interval(5000).subscribe(() => this.getPagseguroSession())
        }
      )

  }

  connectPayment(data, subject: Subject<any>) {

    const expirationMonth = data.expirationDate.substr(0, 2);
    const expirationYear = data.expirationDate.substr(2);
    subject.next(true);
    this.PagSeguroDirectPayment.createCardToken({
      cardNumber: data.cardNumber,
      brand: data.brandCard,
      cvv: data.cvv,
      expirationMonth,
      expirationYear,
      success: (response) => {
        // Retorna o cartão tokenizado.        
        const user = JSON.parse(localStorage.getItem('token'));
        const { card: { token } } = response;
        const holderName = data.holderName;       
        
        this.http.save('pagseguro:payment', {
          userId: user.id,
          cardToken: token,
          holderName
        }).subscribe(
          (result: any) => {
            if(result.type === 'OK') {
              subject.next(result);
            }
          },
          err => {
            subject.error(false)
          }
        );

      },
      error: (response) => {
        subject.error(response)
      }
    });

  }

  unsubscribe() {

    if(this.pagseguroSessionSubscription)
        this.pagseguroSessionSubscription.unsubscribe();

    if(this.submitCartSubscription)
      this.submitCartSubscription.unsubscribe();

  }

  tryPayment(data: any, submitSubject: Subject<any>) {

    if(!this.hasPagseguroSession) {  

      localStorage.setItem('cardCache', JSON.stringify(data));
      
      this.submitCartSubscription = interval(5000)
        .subscribe(
          _ => {
            const data = JSON.parse(localStorage.getItem('cardCache'));
            const subject = new Subject<any>();

            submitSubject
              .pipe(take(1))
              .subscribe(
              () => {
                
                this.submitCartSubscription.unsubscribe();
                localStorage.removeItem('cardCache');
              },
              (err) => {
                  console.error('err!', err)
                  this.submitCartSubscription.unsubscribe();
                  localStorage.removeItem('cardCache');
              }
            )

            subject.subscribe(
              cardBrand => {
                if(cardBrand) {                  
                  data.brandCard = cardBrand;
                  this.connectPayment(data, submitSubject);
                }
              }
            )
            
            if(data)
              this.getCardBrand(data.cardNumber, subject);                          
          },
          err => submitSubject.error(err)
        )
      submitSubject.next(true);
      return;
    }

    this.connectPayment(data, submitSubject);

  }

}